.spectrum--light .spectrum-Underlay {
  background: rgba(0,0,0,0.4);
}
